import '../../css/pages/blog.scss';

function init() {
    console.log("You are on the blog page");

    const toggleButton = document.querySelector('.js-toggle-categories') as HTMLImageElement;
    toggleButton?.addEventListener('click', e => {
        e.preventDefault();
        const container = document.querySelector('.blog-categories__list') as HTMLElement;
        container.classList.toggle('show');
    });

    const searchForm = document.getElementById('keywords') as HTMLFormElement;
    searchForm?.addEventListener('submit', e => {
        e.preventDefault();
        const searchQuery = searchForm.querySelector('input') as HTMLInputElement;
        const formGroup = searchForm.querySelector('.form-group') as HTMLElement;
        if (searchQuery.value != "") location.href = `/help-advice?keywords=${searchQuery.value}`;
        else formGroup.classList.add('is-invalid');
    });
}

const exit = () => {
    console.log("Blog: Exit");
};

window.blog = {
    init,
    exit
};